<template>
  <section class="Images" id="Images">
    <div class="images_wrapper">
      <div class="title_wrapper">
        <h1 class="title">
          Galería
        </h1>
      </div>
      <div v-if="!imagesList.length" class="empty_images">
        <div class="empty_images_wrapper">
          <div class="square">
          </div>
          <p>
            No se encontraron imagenes
          </p>
        </div>
      </div>
      <div v-show="imagesList.length" class="images_list">
        <div class="swiper-container images">
          <div class="swiper-wrapper">
            <article class="swiper-slide image" v-for="image in imagesList" :key="image.id" @click="selectImage(image.url)">
              <img loading="lazy" :src="image.url"  />
            </article>
            <router-link to="/galeria" class="swiper-slide more" v-if="imagesList.length == 5" >
              <div class="plus">
              </div>
              <p>
                Más Imagenes
              </p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.min.css'
import { firestore } from '@/main'
Swiper.use([Navigation, Pagination])

export default {
  name: "Images",
  data: () => ({
    imagesList: [],
    offsetStart: 0,
    mySwiper: null
  }),
  mounted () {
    this.getOffset()
    this.getAllimages()
    this.mySwiper = new Swiper('.swiper-container.images', {
      slidesPerView: 4,
      spaceBetween: 30,
      slidesOffsetBefore: this.offsetStart,
      slidesOffsetAfter: this.offsetStart,
      observer: true,
      observeParents: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 25,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        400: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        760: {
          slidesPerView: 3,
        },
        980: {
          slidesPerView: 4,
        },
        1200: {
          slidesPerView: 5,
        },
        // 1700: {
        //   slidesPerView: 3,
        // },
        // 1900: {
        //   slidesPerView: 3,
        // },
      }
    })
    // document.querySelector('#Home').addEventListener('scroll', () => {
    //   const about = document.getElementById('About')
    //   // const firstChild = document.getElementById('level_default')
    //   let top = document.documentElement.scrollTop
    //   let height = document.documentElement.clientHeight

    //   if ( top + (height / 1.2) > about.offsetTop + (about.clientHeight / 2) ) {
    //     about.classList.add('trigger')
    //     // setTimeout(() => {
    //     //   firstChild.classList.add('trigger')
    //     // }, 800);
    //   }
    // })
  },
  methods: {
    selectImage(url) {
      this.$emit("selectImage", url)
    },
    getAllimages() {
      firestore
        .collection('images')
        .orderBy('initial', 'desc')
        .limit(5)
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            const data = doc.data()
            this.imagesList.push({
              id: doc.id,
              url: data.url,
              initial: data.initial || false
            })
          })
        })
        .catch(console.error)
    },
    getOffset () {
      const title = document.querySelector('#objectives_title')
      this.offsetStart = title.getBoundingClientRect().left
      window.addEventListener('resize', () => {
        if (window.innerWidth > 760) {
          this.mySwiper.params.slidesOffsetBefore = title.getBoundingClientRect().left
          this.mySwiper.params.slidesOffsetAfter = title.getBoundingClientRect().left
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../assets/css/app.sass'
.Images
  background-color: $primary_color
  height: 650px
  overflow: hidden
  .images_wrapper
    opacity: 1
    transition: all ease-in-out .5s .5s
    position: relative
    .square
      height: 20px
      width: 20px
      margin-left: -30px
      background-color: $accent_color
      position: relative
      &:before
        position: relative
        content: ''
        display: block
        right: -20px
        bottom: -20px
        width: 20px
        height: 20px
        background-color: $secondary_color
    .empty_images
      display: flex
      justify-content: center
      align-items: center
      .empty_images_wrapper
        display: flex
        flex-direction: column
        align-items: center
        margin-top: 12rem
        p
          margin-top: 50px
          color: #546397
          font-family: $font
          width: 200px
          text-align: center
          line-height: 1.6
          font-size: 13px
    .swiper-container
      overflow: inherit
    .title_wrapper
      display: flex
      justify-content: flex-start
      padding-left: 70px
      box-sizing: border-box
      width: 980px
      padding-top: 7rem
      margin: 0 auto
    .images_list
      margin-top: 80px
      position: relative
      z-index: 20
      .more
        display: flex
        justify-content: center
        align-items: center
        background-color: #182a61
        color: white
        cursor: pointer
        transition: all ease-in-out .3s
        text-decoration: none
        &:hover
          background-color: $primary_light_color
        .plus
          width: 4px
          height: 20px
          background-color: #fff
          position: relative
          &:before
            content: ''
            position: absolute
            left: -8px
            top: 8px
            height: 4px
            width: 20px
            background-color: #fff
        p
         margin-top: 20px
         font-size: 14px
      .events
        left: 0
        top: 0
      article, a
        background-color: white
        box-sizing: border-box
        height: 300px
        font-family: $font
        color: $primary_color
        display: flex
        flex-direction: column
        cursor: pointer
        img
          width: 100%
          height: 100%
          object-fit: cover
          display: block
@media screen and (max-width: 980px)
  .Images
    height: 420px
    .images_wrapper
      .title_wrapper
        width: 760px
        padding-top: 5rem
      .images_list
        margin-top: 50px
        article, a
          height: 200px

@media screen and (max-width: 760px)
  .Images
    .images_wrapper
      .title_wrapper
        width: 480px
        padding-left: 0

@media screen and (max-width: 560px)
  .Images
    .images_wrapper
      .title_wrapper
        width: 320px

@media screen and (max-width: 400px)
  .Images
    .images_wrapper
      width: 100%
      padding:
        left: 40px
        right: 40px
      box-sizing: border-box
      align-items: flex-start
      .title_wrapper
        width: 100%
        padding-left: 0
        justify-content: flex-start

</style>